<template>
  <div class="home">
    <div class="banner-container">
      <div id="main">
        <div class="flexslider banner-box">
          <ul class="slides">
            <li><img src="../../src/assets/images/5.png" /></li>
            <li><img src="../../src/assets/images/web3-20.png" /></li>
          </ul>
        </div>

      </div>
    </div>
    <!--<div id="item-2" class="banner-container">-->
      <!--<ul class="banner-box">-->
        <!--<li>-->
          <!--<img src="../../src/assets/images/5.png" alt="">-->
        <!--</li>-->
      <!--</ul>-->
    <!--</div>-->
    <div class="container home-content-box">
      <div class="col-lg-offset-1 col-lg-10">
        <ol id="company-infos" class="row">
          <li class="col-md-offset-0 col-sm-offset-0 col-md-4 col-sm-4 col-xs-offset-2 col-xs-8 company-sign"><img src="../../src/assets/images/6.jpg" alt=""></li>
          <li class="col-md-7 col-sm-7 col-xs-12 company-txt">
            <p>
                {{$t("home.company_profile")}}
            </p>
            <!--<p>“丁丁云康”愿通过自己的努力成为每个人的贴身健康管家，使健康自我管理与促进成为大家每日生活中随时、随地可以轻松实现的工作，不再复杂、繁重。</p>-->
            <a href="">{{$t("common.more")}}</a>
          </li>
        </ol>
        <!--<div class="cutting-line"></div>-->
        <!--<ol id="news-infos" class="row">-->
        <!--<h4 class="title-md title-md-0"><a href="javascript:0;">新闻动态<em>News</em></a></h4>-->
        <!--<li class="col-md-4 col-sm-4 col-md-offset-0 col-sm-offset-0 col-xs-offset-2 col-xs-8"><img src="images/1.png" alt=""></li>-->
        <!--<li class="col-md-4 col-sm-4 col-md-offset-0 col-sm-offset-0 col-xs-offset-1 col-xs-10 news-lists">-->
        <!--<h4 class="title-md title-md-1"><a target="_self" href="javascript:0;">新闻动态<em>News</em><img src="images/right.png" alt=""></a></h4>-->
        <!--<ul class="news-lists-wrap">-->
        <!--<li>-->
        <!--<a href="###">-->
        <!--<p>-->
        <!--丁丁云康新闻动态咨询实例-->
        <!--</p>-->
        <!--<span>2017-10-10</span>-->
        <!--</a>-->
        <!--</li>-->
        <!--<li>-->
        <!--<a href="###">-->
        <!--<p>-->
        <!--丁丁云康新闻动态咨询实例-->
        <!--</p>-->
        <!--<span>2017-10-10</span>-->
        <!--</a>-->
        <!--</li>-->
        <!--<li>-->
        <!--<a href="###">-->
        <!--<p>-->
        <!--丁丁云康新闻动态咨询实例-->
        <!--</p>-->
        <!--<span>2017-10-10</span>-->
        <!--</a>-->
        <!--</li>-->
        <!--<li>-->
        <!--<a href="###">-->
        <!--<p>-->
        <!--丁丁云康新闻动态咨询实例-->
        <!--</p>-->
        <!--<span>2017-10-10</span>-->
        <!--</a>-->
        <!--</li>-->
        <!--<a class="xs-newsinfos" href="javascript:0;">更多>></a>-->

        <!--</ul>-->
        <!--</li>-->

        <!--<li class="col-md-4 col-sm-4 col-xs-12 last-video">-->
        <!--<div class="cutting-line cutting-line-0"></div>-->
        <!--<h4 class="title-md title-md-3"><a href="###">精彩视频<em>Videos</em><img src="images/right.png" alt=""></a></h4>-->
        <!--<div>-->
        <!--<video controls width="100%" src="../static/video.mp4"></video>-->
        <!--</div>-->

        <!--</li>-->
        <!--</ol>-->
        <div class="cutting-line"></div>
        <div class="health-help">
          <h4 class="title-md"><a href="###">{{$t("home.health_intervention")}}<em>Health Intervention</em></a></h4>
          <ol class="row health-help-ol">
            <li class="col-md-4 col-sm-4 col-md-offset-0 col-sm-offset-0 col-xs-8 col-xs-offset-2">
              <img src="../../src/assets/images/2.png" alt="">
            </li>
            <li class="col-md-6 col-sm-6 col-xs-12">
              <p>
                {{$t("home.health_intervention_desc")}}
            </p>
              <a href="###">{{$t("common.more")}}</a>
            </li>
          </ol>
        </div>
        <div class="cutting-line"></div>
        <div class="company-partner">
          <h4 class="title-md"><a href="###">{{$t("home.partner_organization")}}<em>Partner Organization</em></a></h4>
          <ol class="row partner-lists">
            <li class="col-md-12"><img src="../../src/assets/images/4.png" alt=""></li>
            <!--<li class="col-md-2 col-sm-2 col-xs-4"><img src="./src/assets/images/u0.png" alt=""></li>-->
            <!--<li class="col-md-2 col-sm-2 col-xs-4"><img src="./src/assets/images/u0.png" alt=""></li>-->
            <!--<li class="col-md-2 col-sm-2 col-xs-4"><img src="./src/assets/images/u0.png" alt=""></li>-->
            <!--<li class="col-md-2 col-sm-2 col-xs-4"><img src="./src/assets/images/u0.png" alt=""></li>-->
            <!--<li class="col-md-2 col-sm-2 col-xs-4"><img src="./src/assets/images/u0.png" alt=""></li>-->
            <!--<li class="col-md-2 col-sm-2 col-xs-4"><img src="./src/assets/images/u0.png" alt=""></li>-->
          </ol>
        </div>
      </div>


    </div>
    <router-view></router-view>

  </div>
</template>

<script>
    export default {
        name: 'home',
        data () {
            return {
              locationUrl:''
            }
        },
        mounted (){
            this.$nextTick(()=>{
              $(".flexslider").flexslider({
                slideshowSpeed: 4000, //展示时间间隔ms
                animationSpeed: 400, //滚动时间ms
                touch: true //是否支持触屏滑动
              })
            })

        },
        methods:{

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*@import '../assets/css/reset.css';*/
  /*@import '../assets/css/style.css';*/
</style>



// WEBPACK FOOTER //
// Home.vue?2cb20d4b